import CustomizationService from './CustomizationService';

export default CustomizationService;
